import gql from 'graphql-tag';

export const GET_DATA_FOR_BILL_PAY_CTA_QUERY = gql`
  query GetDataForBillPayCta($planId: Int!) {
    plan(id: $planId) {
      id
      paymentMethod {
        id
      }
      utilityAccounts {
        id
        enrollmentDataSourceName
        targetBillExperience
        mostRecentUtilityStatement {
          id
          dueDate
          utilityCharge
        }
        utility {
          id
          displayName
        }
      }
    }
  }
`;

export const GET_BILLING_EXPERIENCE_OPTIONS = gql`
  query GetBillingExperienceOptions(
    $utilityId: Int!
    $enrollmentDataSourceName: EnrollmentOptionName!
  ) {
    billingExperienceOptions(
      utilityId: $utilityId
      enrollmentDataSourceName: $enrollmentDataSourceName
    ) {
      name
    }
  }
`;

export const getDataForBillPayCtaMock = {
  plan: {
    id: 1,
    paymentMethod: {
      id: 1000,
    },
    utilityAccounts: [
      {
        id: 5,
        enrollmentDataSourceName: 'utility_connect',
        targetBillExperience: 'dual_billed',
        mostRecentUtilityStatement: {
          dueDate: '9/3/2020',
          id: 2,
          utilityCharge: 12.44,
        },
        utility: {
          displayName: 'Pepco',
          id: 1111,
        },
      },
    ],
  },
};

export const getDataForBillPayCtaWithoutPaymentMethodMock = {
  plan: {
    id: 1,
    paymentMethod: null,
    utilityAccounts: [
      {
        id: 5,
        enrollmentDataSourceName: 'utility_connect',
        targetBillExperience: 'dual_billed',
        mostRecentUtilityStatement: {
          dueDate: '9/3/2020',
          id: 2,
          utilityCharge: 12.44,
        },
        utility: {
          displayName: 'Pepco',
          id: 1111,
        },
      },
    ],
  },
};

export const getBillingExperienceOptionsMock = {
  billingExperienceOptions: [
    {
      name: 'dual',
    },
    {
      name: 'acb',
    },
    {
      name: 'ucb',
    },
  ],
};

export const getBillingExperienceOptionsNonUCBMock = {
  billingExperienceOptions: [
    {
      name: 'dual',
    },
    {
      name: 'acb',
    },
  ],
};

export const getBillingExperienceOptionsEmptyMock = {
  billingExperienceOptions: [],
};
